module.exports = __webpack_public_path__ + "onboarding-feed-localdirectory.35be4a9869787c66b646c2d613ddad85.hashedasset.svg";